module.exports = "//static.hsappstatic.net/pricing-pages-unified-ui/static-1.14976/js/img/peopleBlobs/payments-smiling-person.png"